import * as React from 'react'
import Link from 'next/link'
import useApp from '@/lib/store'

import { cn } from '@/lib/utils'

type FooterNavLinksProps = {
	site: any
	pathname: string
	className?: string
}

export default function FooterNavLinks({ site, pathname, className }: FooterNavLinksProps) {
	const { setIsNavOpen } = useApp()
	const links = site?.navItems
	if (!links || !links.length) return null
	return (
		<ul className={cn(' flex flex-col items-end md:items-start gap-6', className)}>
			{site?.navItems?.map((item) => (
				<li key={item?.title} className="style-nav-item">
					<Link
						href={item?.url}
						onClick={() => setIsNavOpen(false)}
						className={cn(' text-white hover:text-blue transition', {
							'underline underline-offset-4': pathname == item?.url
						})}>
						{item?.title}
					</Link>
				</li>
			))}
		</ul>
	)
}
